import React, { useState } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import {
  Box, Button, TextField, Typography, Paper, CircularProgress
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

function ConsumoAguaRelatorio({ refresh }) {
  const { user } = useAuth();
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [loadingPdf, setLoadingPdf] = useState(false);

  const handleDownloadPDF = () => {
    if (!dataInicio || !dataFim) return;
    setLoadingPdf(true);

    const params = { data_inicio: dataInicio, data_fim: dataFim };
    if (user?.tipo_usuario === 'admin' && user?.empresa_id) {
      params.empresa_id = user.empresa_id;
    }

    api.get('/consumo-agua/relatorio-pdf', { params, responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        window.open(url, '_blank');
      })
      .catch((error) => {
        console.error('Erro ao gerar PDF:', error);
      })
      .finally(() => {
        setLoadingPdf(false);
      });
  };

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Relatório por Período
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <TextField
          label="Data Início"
          type="date"
          value={dataInicio}
          onChange={(e) => setDataInicio(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Data Fim"
          type="date"
          value={dataFim}
          onChange={(e) => setDataFim(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <Button
          variant="contained"
          startIcon={<PictureAsPdfIcon />}
          onClick={handleDownloadPDF}
          disabled={!dataInicio || !dataFim || loadingPdf}
        >
          {loadingPdf ? <CircularProgress size={24} color="inherit" /> : 'Gerar PDF'}
        </Button>
      </Box>
    </Paper>
  );
}

export default ConsumoAguaRelatorio;
